






import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { FixedPhraseRootReference } from "../../../domain/document";
import { FixedLoading } from "../../system";
import FixedPhraseTreeSelector from "./FixedPhraseTreeSelector.vue";
import { FixedPhraseTreeSelectorMixin } from "./mixins";
import { IEditFixedPhrase } from "./IEditFixedPhrase";
import { FixedPhraseKinds } from "./FixedPhraseKinds";

@Component({
  components: {
    FixedLoading,
    selector: FixedPhraseTreeSelector,
  }
})
export default class FormatFixedPhraseSelector extends Mixins(
  FixedPhraseTreeSelectorMixin,
) implements IEditFixedPhrase {
  @Prop()
  formatOriginalId: number;

  @Prop({ default: true })
  isPastable: boolean;

  get formatOriginalIdText(): string {
    return (this.formatOriginalId == null || this.formatOriginalId === -1)
      ? null  // TODO: これでよいのか確認
      : this.formatOriginalId.toString();
  }

  created(): void {
    this.loadFixedPhrase();
  }

  private async loadFixedPhrase(): Promise<void> {
    this.$logger.debug("loadFixedPhrase() formatOriginalId=" + this.formatOriginalId);
    try {
      if (!this.formatOriginalIdText) {
        // 文書情報（フォーマット情報）取得完了前に読み込みされる場合はformatOriginalId=-1となってしまっている模様
        return;
      }
      this.rootFixedPhrase = await this.getFixedPhrase(FixedPhraseKinds.Format, this.formatOriginalIdText);
    } catch (e) {
      this.rootFixedPhrase = new FixedPhraseRootReference(null, null, []);
      this.$error(
        "書類定型文取得失敗",
        "書類定型文を読み込めませんでした。",
        e);
    }
  }

  @Watch("formatOriginalId")
  onFormatOriginalIdUpdated(newValue: number, oldValue: number): void {
    this.$logger.debug("onFormatOriginalIdUpdated() newValue=" + newValue + ", oldValue=" + oldValue);
    this.loadFixedPhrase();
  }

  mounted(): void {
    this.selector = this.$refs.selector;
  }

  @Emit("doubleClicked")
  doubleClicked(): void {}

  @Emit("dragStart")
  dragStart(event: DragEvent, text: string): void {}

  async editFixedPhrase(): Promise<void> {
    if (!this.isLoaded) {
      return;
    }
    return this.executeWithManagementTokenControll("定型文", isForcibly => this.getManagementToken(FixedPhraseKinds.Format, isForcibly, this.formatOriginalIdText), this.executeEditFixedPhrase);
  }

  private async executeEditFixedPhrase(): Promise<void> {
    const latest = await this.getFixedPhrase(FixedPhraseKinds.Format, this.formatOriginalIdText);
    const result = await this.getEditedFixedPhrase(latest, FixedPhraseKinds.Format, this.formatOriginalIdText);
    if (result == null) { return; }
    await this.setFixedPhrase(FixedPhraseKinds.Format, result);
  }
}
